import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const GENERAL_AMENITIES = [
    'WiFi gratuit', 'Parcare privata', 'Restaurant', 'Piscina incalzita', 'Sala de sport',
    'Piscina interioara', 'Piscina exterioara', 'Ciubar', 'Jacuzzi', 'Sauna uscata',
    'Sauna umeda', 'Sala de fitness', 'Masaj', 'Tratamente Spa', 'Sala de jocuri', 'Gratar',
    'Baie proprie', 'Baie comuna', 'Bucatarie', 'Crama sau pivnita', 'Restaurant cu specific',
    'Bar', 'Parc de distractii', 'Loc pentru animale de companie', 'Spatiu de joaca pentru copii',
    'Inchirieri biciclete', 'Inchirieri echipament sportiv', 'Plimbari de agrement',
    'Sala de conferinte', 'Sala de evenimente', 'Inchirieri auto', 'TV in camera',
    'Cada cu hidromasaj', 'Semineu', 'Soba pe lemne', 'Plata cu card bancar',
    'Plata cu vouchere de vacanta'
];

const AGROTURISM_AMENITIES = [
    'Animale de ferma', 'Plante medicinale', 'Turism ecologic', 'Bucatarie traditionala',
    'Produse de ferma', 'Degustari produse proprii', 'Culesul granelor', 'Tur ghidat al fermei',
    'Hranirea animalelor', 'Pasune / Stana', 'Zona cu animale prietenoase', 'Atelier de olarit',
    'Atelier de preparare a branzeturilor', 'Atelier de coacere a painii',
    'Atelier de preparare dulceturi', 'Atelier de preparare a sucurilor naturale', 'Atelier de tesut',
    'Atelier de prelucrare a lemnului', 'Ateliere specifice pentru copii', 'Gradina cu legume',
    'Gradina cu zarzavaturi', 'Plimbari cu caruta', 'Calarie', 'Camere in stil traditional',
    'Camere cu vatra sau semineu', 'Cuptor traditional', 'Izolatie naturala', 'Pescuit', 'Munca la pamant'
];

const ROOM_TYPES = ['Single', 'Tripla', 'Dubla', 'Twin', 'Apartament'];

export default function AdvancedSearch() {
    const navigate = useNavigate();

    const [query, setQuery] = useState('');
    const [location, setLocation] = useState('');
    const [checkIn, setCheckIn] = useState('');
    const [checkOut, setCheckOut] = useState('');
    const [adults, setAdults] = useState(1);
    const [children, setChildren] = useState(0);
    const [propertyType, setPropertyType] = useState('');
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');

    const [selectedGeneral, setSelectedGeneral] = useState([]);
    const [selectedAgro, setSelectedAgro] = useState([]);
    const [selectedRooms, setSelectedRooms] = useState([]);

    const toggleSelection = (item, list, setList) => {
        if (list.includes(item)) setList(list.filter(i => i !== item));
        else setList([...list, item]);
    };

    const handleBack = () => navigate('/');

    const handleSearch = () => {
        const result = {
            query, location, checkIn, checkOut, adults, children, propertyType, minPrice, maxPrice,
            selectedGeneral, selectedAgro, selectedRooms
        };
        navigate('/search', { state: result });
        // aici se poate trimite request catre backend
    };

    const renderCheckboxList = (items, selectedList, setSelected) => (
        <div className="checkbox-grid">
            {items.map(item => (
                <label key={item} className="checkbox-label">
                    <input
                        type="checkbox"
                        checked={selectedList.includes(item)}
                        onChange={() => toggleSelection(item, selectedList, setSelected)}
                        className="checkbox-input"
                    />
                    <span className="checkbox-text">{item}</span>
                </label>
            ))}
        </div>
    );

    return (
        <div className="advanced-search">
            <button className="back-button" onClick={handleBack}>⬅ Inapoi</button>

            <h1 className="main-title">Cautare Avansata</h1>

            <div className="form-section">
                <div className="field-group">
                    <div className="row">
                        <input
                            type="text"
                            placeholder="Titlu sau descriere..."
                            value={query}
                            onChange={e => setQuery(e.target.value)}
                            className="search-input"
                        />
                        <input
                            type="text"
                            placeholder="Localitate / Judet / Regiune"
                            value={location}
                            onChange={e => setLocation(e.target.value)}
                            className="search-input"
                        />
                    </div>

                    <div className="row">
                        <div className="date-field">
                            <label className="date-label">Check-in</label>
                            <input
                                type="date"
                                value={checkIn}
                                onChange={e => setCheckIn(e.target.value)}
                                className="date-input"
                            />
                        </div>
                        <div className="date-field">
                            <label className="date-label">Check-out</label>
                            <input
                                type="date"
                                value={checkOut}
                                onChange={e => setCheckOut(e.target.value)}
                                className="date-input"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="guest-field">
                            <label className="guest-label">Adulti</label>
                            <input
                                type="number"
                                min={1}
                                value={adults}
                                onChange={e => setAdults(e.target.value)}
                                className="guest-input"
                            />
                        </div>
                        <div className="guest-field">
                            <label className="guest-label">Copii</label>
                            <input
                                type="number"
                                min={0}
                                value={children}
                                onChange={e => setChildren(e.target.value)}
                                className="guest-input"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="select-field">
                            <label className="select-label">Tip proprietate</label>
                            <select
                                value={propertyType}
                                onChange={e => setPropertyType(e.target.value)}
                                className="type-select"
                            >
                                <option value="">Selecteaza tipul</option>
                                <option value="Pensiune">Pensiune</option>
                                <option value="Ferma">Ferma</option>
                                <option value="Cabana">Cabana</option>
                                <option value="Hotel">Hotel</option>
                                <option value="Motel">Motel</option>
                                <option value="Hostel">Hostel</option>
                                <option value="Vila">Vila</option>
                                <option value="Han">Han</option>
                                <option value="Guest House">Guest House</option>
                                <option value="Camping">Camping</option>
                                <option value="Glamping">Glamping</option>
                                <option value="Rulote">Rulote</option>
                            </select>
                        </div>

                        <div className="price-group">
                            <div className="price-field">
                                <label className="price-label">Pret minim</label>
                                <input
                                    type="number"
                                    placeholder="0"
                                    value={minPrice}
                                    onChange={e => setMinPrice(e.target.value)}
                                    className="price-input"
                                />
                            </div>
                            <div className="price-field">
                                <label className="price-label">Pret maxim</label>
                                <input
                                    type="number"
                                    placeholder="1000"
                                    value={maxPrice}
                                    onChange={e => setMaxPrice(e.target.value)}
                                    className="price-input"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="amenities-section">
                <h2 className="section-title">Dotari generale</h2>
                {renderCheckboxList(GENERAL_AMENITIES, selectedGeneral, setSelectedGeneral)}
            </section>

            <section className="amenities-section">
                <h2 className="section-title">Dotari agroturism</h2>
                {renderCheckboxList(AGROTURISM_AMENITIES, selectedAgro, setSelectedAgro)}
            </section>

            <section className="amenities-section">
                <h2 className="section-title">Tipuri camere</h2>
                {renderCheckboxList(ROOM_TYPES, selectedRooms, setSelectedRooms)}
            </section>

            <button className="search-button" onClick={handleSearch}>Cauta</button>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600&display=swap');
                
                * {
                    box-sizing: border-box;
                }
                
                .advanced-search {
                    font-family: 'Sora', sans-serif;
                    color: #006d77;
                    padding: 12px;
                    max-width: 100%;
                    overflow-x: hidden;
                    font-size: 0.8rem;
                }
                
                .back-button {
                    background: #006d77;
                    color: white;
                    border: none;
                    padding: 10px 16px;
                    border-radius: 6px;
                    margin-bottom: 16px;
                    cursor: pointer;
                    font-size: 0.8rem;
                    font-weight: 600;
                    width: 100%;
                }
                
                .main-title {
                    font-size: 1.2rem;
                    margin-bottom: 16px;
                    text-align: center;
                    font-weight: 600;
                    color: #006d77;
                }
                
                .form-section {
                    background: #f8f9fa;
                    border-radius: 8px;
                    padding: 16px;
                    margin-bottom: 20px;
                }

                .field-group .row {
                    display: flex;
                    gap: 12px;
                    margin-bottom: 12px;
                }

                .field-group .row > div,
                .field-group .row > input,
                .field-group .row > select {
                  flex: 1;
                }

                .search-input {
                    font-size: 0.8rem;
                    padding: 10px;
                    margin-bottom: 12px;
                    border: 1px solid #006d77;
                    border-radius: 6px;
                    outline: none;
                    width: 100%;
                    background: white;
                    line-height: 1.2;
                }
                
                .date-group, .guests-group, .price-group {
                    display: flex;
                    gap: 8px;
                    margin-bottom: 12px;
                }
                
                .date-field, .guest-field, .price-field, .select-field {
                    flex: 1;
                }
                
                .date-label, .guest-label, .price-label, .select-label {
                    display: block;
                    font-size: 0.8rem;
                    margin-bottom: 4px;
                    color: #006d77;
                    font-weight: 600;
                    line-height: 1.2;
                }
                
                .date-input, .guest-input, .price-input, .type-select {
                    width: 100%;
                    padding: 8px;
                    border: 1px solid #006d77;
                    border-radius: 6px;
                    font-size: 0.8rem;
                    background: white;
                    color: #006d77;
                    line-height: 1.2;
                    height: 36px;
                }
                
                .type-select {
                    height: 36px;
                }
                
                .amenities-section {
                    margin-bottom: 20px;
                    padding: 0;
                }
                
                .section-title {
                    font-size: 0.9rem;
                    margin-bottom: 8px;
                    font-weight: 600;
                    color: #006d77;
                    text-align: left;
                    line-height: 1.2;
                }
                
                .checkbox-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 6px 8px;
                    max-height: 200px;
                    overflow-y: auto;
                    border: 1px solid #006d77;
                    border-radius: 6px;
                    padding: 10px;
                    background: white;
                }
                
                .checkbox-label {
                    display: flex;
                    align-items: flex-start;
                    gap: 6px;
                    font-size: 0.8rem;
                    text-align: left;
                    cursor: pointer;
                    padding: 0;
                    margin: 0;
                    line-height: 1.2;
                }
                
                .checkbox-input {
                    margin-top: 2px;
                    min-width: 14px;
                    min-height: 14px;
                    accent-color: #006d77;
                    cursor: pointer;
                    flex-shrink: 0;
                }
                
                .checkbox-text {
                    flex: 1;
                    word-break: break-word;
                    line-height: 1.2;
                }
                
                .search-button {
                    margin-top: 20px;
                    background: #dd4124;
                    color: white;
                    padding: 12px;
                    border: none;
                    border-radius: 6px;
                    font-weight: 600;
                    font-size: 0.8rem;
                    cursor: pointer;
                    width: 100%;
                    line-height: 1.2;
                }
                
                /* Scrollbar styling */
                .checkbox-grid::-webkit-scrollbar {
                    width: 4px;
                }
                
                .checkbox-grid::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 2px;
                }
                
                .checkbox-grid::-webkit-scrollbar-thumb {
                    background: #006d77;
                    border-radius: 2px;
                }
                
                /* Responsive adjustments */
                @media (max-width: 640px) {
                    .checkbox-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                    
                    .date-group, .guests-group, .price-group {
                        flex-direction: column;
                        gap: 10px;
                    }
                    
                    .advanced-search {
                        padding: 10px;
                    }
                    
                    .form-section {
                        padding: 12px;
                    }
                }
                
                @media (max-width: 480px) {
                    .checkbox-grid {
                        grid-template-columns: 1fr;
                        gap: 4px;
                    }
                    
                    .advanced-search {
                        padding: 8px;
                        font-size: 0.75rem;
                    }
                    
                    .form-section {
                        padding: 10px;
                    }
                    
                    .section-title {
                        font-size: 0.85rem;
                    }
                    
                    .checkbox-label {
                        font-size: 0.75rem;
                        gap: 4px;
                    }
                }
                
                @media (min-width: 768px) {
                    .advanced-search {
                        max-width: 768px;
                        margin: 0 auto;
                    }
                    
                    .checkbox-grid {
                        max-height: 180px;
                    }
                }
                
                @media (min-width: 1024px) {
                    .checkbox-grid {
                        grid-template-columns: repeat(3, 1fr);
                        max-height: 160px;
                    }
                }
            `}</style>
        </div>
    );
}